import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { CallToActionAreaConsumer, transformLinkUri } from "gatsby-theme-gba"

const CallToActionAreaEditable = ({ blok }) => {
  let link

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  if (blok.link.linktype === "email") {
    link = `mailto:${blok.link.email}`
  } else if (blok.link.linktype === "story") {
    link = blok.link.id ? blok.link.id : blok.link.cached_url
  } else {
    link = blok.link.url ? blok.link.url : "/home"
  }

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <CallToActionAreaConsumer
        heading={blok.heading || "Headline"}
        subHeading={blok.subHeading || "Your Subheadline"}
        buttonLink={link}
        download={blok.link && blok.link.linktype === "asset"}
        buttonText={blok.linkText}
        linkTarget={blok.linkTarget}
        triggerSearchDialog={blok.triggerSearch}
        currentLanguage={blok.currentLanguage}
        mode={blok.mode}
        disableHyphens={blok.disableHyphens}
      >
        <Markdown
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {replaceAll(blok.body, "\u2028", "")}
        </Markdown>
      </CallToActionAreaConsumer>
    </div>
  )
}

export default CallToActionAreaEditable
